// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .rbt {
    position: absolute !important;
} */

.react-datepicker__input-container {
    display: flex !important;
    align-items: center !important;
}

.react-datepicker__input-container input {
    padding-right: 40px !important;
    flex: 1 1 !important;
}

.react-datepicker__calendar-icon {
    position: absolute !important;
    right: 10px !important;
    pointer-events: all !important;
    padding: 5px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

/* Compact column widths */
.compact-name {
    width: 12% !important;
    max-width: 150px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.compact-email {
    width: 15% !important;
    max-width: 180px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.compact-address {
    width: 18% !important;
    max-width: 200px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/reports/reports.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,oBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA,0BAA0B;AAC1B;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":["/* .rbt {\n    position: absolute !important;\n} */\n\n.react-datepicker__input-container {\n    display: flex !important;\n    align-items: center !important;\n}\n\n.react-datepicker__input-container input {\n    padding-right: 40px !important;\n    flex: 1 !important;\n}\n\n.react-datepicker__calendar-icon {\n    position: absolute !important;\n    right: 10px !important;\n    pointer-events: all !important;\n    padding: 5px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n/* Compact column widths */\n.compact-name {\n    width: 12% !important;\n    max-width: 150px !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.compact-email {\n    width: 15% !important;\n    max-width: 180px !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.compact-address {\n    width: 18% !important;\n    max-width: 200px !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
